<template>
  <div>
    <section>
        <div class="flex-row section-container">
            <div class="flex-column flex-item-center flex-grow card-wrapper">
                <div class="flex-row flex-row-gap card-container">
                    <template v-for="item in newsArticles">
                        <router-link class="news-link" :to="{path: '' + item.id}">
                            <card class="landing-cards news-card neutral no-padding">
                                <template #image>
                                    <img :src="item.coverImg.url"/>
                                </template>
                                <div>
                                    <h3>
                                        {{ item.title }}
                                    </h3>
                                    <p>
                                        {{item.thumbnailDescription}}
                                    </p>
                                </div>
                                <template #footer>
                                    <p class="card-text">
                                        Read more
                                    </p>
                                </template>
                            </card>
                        </router-link>
                    </template>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>
<script>
import strapiServices from '../services/StrapiServices';
import strapiMixins from "../utilities/strapiMixins";

export default {
  components: {

  },
  mixins: [strapiMixins],
  data() {
    return {

    };
  },
  created () {
    
  },
  mounted() {
    this.getNews();
  },
  filters: {
    
  },
  computed: {
    
  },
  methods: {
    async getNews() {
        try {
            let response = await strapiServices.GET_STRAPI("news-articles/");
            let articles = this.getArticles(response);
            this.newsArticles = articles;
        } catch (err) {
            console.log(err);
        }
    }
  }
};</script>
<style lang="scss">
</style>
